/**
 * A rate as the brief pages show it beside another (the 2026-10-24 sweep, item 7.2). A rate's words come from its fact
 * where the brief states one, else from pct: one decimal, two below 0.1%. Two readings of that confuse a plant manager:
 * a rate above nothing that rounds to "0.0%" reads as none, and "0.10%" (a rate just under 0.1%) reads as a different
 * figure from the "0.1%" beside it. So a rate above nothing that rounds to nothing reads "under 0.01%", and "0.10%"
 * reads "0.1%". Nothing else changes: every other figure is its fact's words as stated. Pure.
 */

/** "under 0.01%" for a rate above nothing whose words read "0.0%", "0.1%" for "0.10%", else the words as they are. */
export function shownRate(text: string, value: number | null | undefined): string {
  const t = text.trim();
  if (t === "0.10%") return "0.1%";
  if (t === "0.0%" && typeof value === "number" && value > 0) return "under 0.01%";
  return text;
}
